import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components"

const Wrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100dvw;
    height: 100dvh;
`
const ImgError = styled.img`
    width: 350px;
`

const TextCont = styled.div`
    margin-left: 80px;
    h1 {
        font-size: 50px;
        font-weight: bold;
    }

    p {
        line-height: 1.4;
        margin-top: 20px;
        font-size: 18px;
    }

    .btn {
        margin-top: 30px;
    }
`;
export default function Error({h1, p, btn, link}) {
    const navigate = useNavigate();
    return (
        <Wrap>
            <ImgError src={process.env.PUBLIC_URL + "/image/img_error.svg"}/>

            <TextCont>
                <h1>{h1}</h1>
                <p>
                    {p}
                </p>
                <Button onClick={(e) => {
                    e.preventDefault();
                    navigate(link);
                }} className="btn btn-primary">{btn}</Button>
            </TextCont>
        </Wrap>
    )
}